// Orchestrates the onboarding hero: checklist card, collapsed bar, or the
// one-time "you're live" banner. `status` comes from useOnboardingStatus (the
// Dashboard owns it so the hook runs once and can also gate the data cards).
import { useState } from "react";

import OnboardingCard from "./OnboardingCard";
import OnboardingMinimizedBar from "./OnboardingMinimizedBar";
import OnboardingComplete from "./OnboardingComplete";

const MIN_KEY = "tf_onboarding_minimized";
const DISMISS_KEY = "tf_onboarding_dismissed";

const readFlag = key => {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch (e) {
    return false;
  }
};

const writeFlag = (key, value) => {
  try {
    window.localStorage.setItem(key, value ? "1" : "0");
  } catch (e) {
    /* storage unavailable — fall back to in-memory state only */
  }
};

const Onboarding = ({ status }) => {
  const [minimized, setMinimized] = useState(() => readFlag(MIN_KEY));
  const [dismissed, setDismissed] = useState(() => readFlag(DISMISS_KEY));

  const setMin = value => {
    setMinimized(value);
    writeFlag(MIN_KEY, value);
  };

  const dismiss = () => {
    setDismissed(true);
    writeFlag(DISMISS_KEY, true);
  };

  if (status.allRequiredDone) {
    // Already set up: show the celebration once, then bow out. A forced dev
    // preset (?onboarding=complete) always renders it, ignoring the flag.
    if (dismissed && !status.isDevOverride) return null;
    return <OnboardingComplete status={status} onDismiss={dismiss} />;
  }

  if (minimized) {
    return (
      <OnboardingMinimizedBar status={status} onExpand={() => setMin(false)} />
    );
  }

  return <OnboardingCard status={status} onMinimize={() => setMin(true)} />;
};

export default Onboarding;
